/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";
import React from "react";

export const OrderRowHeaderSkeleton = (props) => (
    <ContentLoader
        height={32}
        width={"100%"}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        {...props}>

        {/* Order number and label */}
        <rect x="0" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* Order reference */}
        <rect x="20%" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* Creation date */}
        <rect x="36%" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* Ship-to number */}
        <rect x="52%" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* City */}
        <rect x="68%" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

    </ContentLoader>
);

